import dynamic from "next/dynamic";
import PlainBannerConfig from "./plain-banner-config";
import PlainBannerAdvancedConfig from "./plain-banner-advanced-config";
const PlainBannerComponent = dynamic(()=>import("./plain-banner-component"));
export default {
    PlainBannerComponent,
    PlainBannerConfig,
    PlainBannerAdvancedConfig
};
